export const SET_FIELD = 'SET_FIELD';
export const REGISTER_FIELD = 'REGISTER_FIELD';
export const SET_SUBMIT = 'SET_SUBMIT';
export const CLEAR_FORM = 'CLEAR_FORM';
export const SET_MANY_FIELDS = 'SET_MANY_FIELDS';
export const UNREGISTER_FIELDS = 'UNREGISTER_FIELDS';
export const START_SUBMIT = 'START_SUBMIT';
export const STOP_SUBMIT = 'STOP_SUBMIT';
